const ContentManagement = () => {
  return (
    <div>ContentManagement</div>
  )
}

export default ContentManagement